import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'FreemiumAllowanceActivatingLabel';

export const useFreemiumAllowanceActivatingLabelStyles = makeStyles<boolean>({
  name,
})((theme, isShortened) => ({
  icon: {
    color: theme.palette.text.secondary,

    '&:hover': isShortened
      ? {
          color: theme.palette.primary.dark,

          cursor: 'pointer',
        }
      : undefined,
  },
  link: {
    cursor: 'pointer',
    textDecoration: `underline dashed ${alpha(
      theme.palette.primary.main,
      0.5,
    )}`,
    textUnderlineOffset: 4,

    '&:hover': {
      color: theme.palette.grey[800],

      textDecoration: `underline dashed ${theme.palette.text.secondary}`,
      textUnderlineOffset: 4,
    },
  },
}));
